import StepThree from "@/components/dashboard/pay/StepThree";

export default function PayStepThree() {
  return <StepThree />;
}
